export default __webpack_public_path__ + "static/media/aydinlatmaMetniEn.be716831.pdf";